import {BaseElement} from "back/commons/basis";
import {IItemUiEnv} from "back/wsp/views/itemMain";
import {IReg, REG} from "lib/commons/registry";
import {IView} from "lib/commons/views";
import {JSX} from "lib/commons/xml/dom";
import {OSpaceTreeInit, SpaceTree, SpaceTreeDuplicate, SpaceTreePaste, SpaceTreePasteMove, SpaceTreeRename} from "back/wsp/views/spaceTree";
import {DeleteSrc, ShortDescCopy} from "back/wsp/actions/srcActions";
import {AccelKeyMgr, Action} from "lib/commons/actions";
import {IShortDescCtx, ITEM} from "lib/wsp/item";
import {ESrcSt, JSrcFields, SRC} from "lib/wsp/src";
import {SrcNewCode} from "back/wsp/dialogs/srcNewCode";
import {POPUP} from "back/commons/widgets/popups";
import {WSP} from "lib/wsp/wsp";

/**
 * View d'une de l'arbre des fichiers d'un item de type folder.
 *
 * Config attributes:
 */
export interface ItemFolderTree extends BaseElement {
	initialize(init: OItemFolderTreeInit): this;
}

export interface OItemFolderTreeInit extends OSpaceTreeInit {
	reg?: IReg<IItemUiEnv>
}

export class ItemFolderTree extends BaseElement implements IView {
	reg: IReg<IItemUiEnv>;
	tree: SpaceTree;

	_initialize(init: OItemFolderTreeInit) {
		this.reg = this.findReg(init);
		this.style.display = "flex";
		this.style.flex = "1";
		//let sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		//this._initAndInstallSkin(this.localName, init);

		init.uriRoot = this.reg.env.longDesc.srcUri;
		if (!('hideSearch' in init)) init.hideSearch = true;
		if (!('actions' in init)) init.actions = this.reg.getList("actions:itemFolder:shortDesc");
		if (!('accelKeyMgr' in init)) init.accelKeyMgr = new AccelKeyMgr<IShortDescCtx>().initFromMapActions(this.reg.getListAsMap("accelkeys:itemFolder:shortDesc"));
		if (!('secondaryCols' in init)) init.secondaryCols = this.reg.getList("columns:itemFoderTree:secondaryCols")

		this.tree = this.appendChild(<SpaceTree style="flex:1" î={init}/>) as SpaceTree;

	}
}

customElements.define("wsp-item-folder-tree", ItemFolderTree);


function addAction(action: Action<IShortDescCtx>, accel?: string) {
	REG.reg.addToList("actions:itemFolder:shortDesc", action.getId(), 1, action);
	if (accel) REG.reg.addToList("accelkeys:itemFolder:shortDesc", accel, 1, action);
}


addAction(ShortDescCopy.SINGLETON, "c-accel");

const pasteCtrl = new SpaceTreePaste();
addAction(pasteCtrl, "v-accel");
addAction(new SpaceTreePasteMove(pasteCtrl));

addAction(new SpaceTreeRename(), "F2");
//addAction(new SpaceTreeMoveTo()); //cible folder (et non space) à revoir.
addAction(new DeleteSrc(), "Delete");
//addAction(new SpaceTreeCopyTo()); //cible folder (et non space) à revoir.
addAction(new SpaceTreeDuplicate());


export class FolderTreeCreateFolder extends Action<SpaceTree> {

	constructor() {
		super('createFolder');
		this._label = "Créer un dossier...";
		this._group = "create";
	}

	isVisible(ctx: SpaceTree): boolean {
		if (ctx.shortDescs.length > 1) return false;
		return super.isVisible(ctx);
	}

	async execute(ctx: SpaceTree, ev?: Event): Promise<JSrcFields> {
		//Chargement asynch
		const {SrcNewCode} = await import("back/wsp/dialogs/srcNewCode.js");
		const parentUri = ctx.shortDescs.length === 0 ? ctx.uriRoot :
			ctx.shortDescs[0].srcSt === ESrcSt.folder ? ctx.shortDescs[0].srcUri : SRC.extractUriParent(ctx.shortDescs[0].srcUri);
		const parentSrcLabel = ITEM.extractSrcLabel(parentUri, "");
		const ti = `Créer un dossier en fils de '${parentSrcLabel}'`;
		const ct = new SrcNewCode().initialize({
			reg: ctx.reg,
			parentFolder: parentUri,
			targetSrcUriType: "res"
		});
		const newCode = await POPUP.showDialog<string | null>(ct, ctx.emitter, {titleBar: {barLabel: {label: ti}}}).onNextClose();
		ctx.emitter.focus();
		if (newCode) {
			try {
				const shortDesc = await WSP.createSpaceOrFolder(ctx.reg.env.wsp, null, ctx.emitter, SRC.addLeafToUri(parentUri, newCode));
				if (shortDesc && await ctx.selectSrcUri(shortDesc.srcUri) && ctx.grid.defaultAction) ctx.grid.defaultAction.executeIfAvailable(ctx);
				return shortDesc;
			} catch (e) {
				//FIXME POPUP.showError()
				throw e;
			}
		}
	}
}

addAction(new FolderTreeCreateFolder());
